import { render, staticRenderFns } from "./partner_article.vue?vue&type=template&id=4097fac2&lang=pug"
import script from "./partner_article.vue?vue&type=script&lang=js"
export * from "./partner_article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports